import { Separator } from '@design-system/Separator';

interface DetectedVirusListProps {
  viruses: string[];
}

export const DetectedVirusList = ({ viruses }: DetectedVirusListProps) => {
  return (
    <div className="space-y-4">
      <h2 className="typography-h1 text-primary">Plant Viruses Detected</h2>
      <div>
        {viruses.map((virus, index) => (
          <div key={index}>
            <p className="typography-body text-primary/70 py-4">
              {virus}
            </p>
              <Separator className="bg-stroke-primary-subtle" />
          </div>
        ))}
      </div>
    </div>
  );
};